<template>
  <div id="page-login">
    <div class="bg-img h-screen flex w-full vx-row no-gutter items-center justify-center">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4" style="max-width: 1300px">
        <div class="vx-row no-gutter justify-center items-center">
          <slide-x-left-transition>
            <div class="vx-col lg:w-4/3 rounded-lg bg-login-card" v-if="transition">
              <vx-card style="border-radius: 10px; border-color: #fff; border-width: 2px; border-style: solid" class="bg-transparent">
                <div slot="no-body">
                  <div class="p-12 pb-6">
                    <div class="vx-card__title">
                      <div class="flex justify-between items-center">
                        <div class="pr-8">
                          <!-- If you are digging through this, you should probably stop and work for us :) -->
                          <h1 class="mb-2 font-bold">Welcome to Academy</h1>
                          <p class="mt-2 font-light">Please sign in using your Intellectual Point Connect account</p>
                        </div>
                        <img
                          alt="login"
                          class="mb-2"
                          width="75px"
                          draggable="false"
                          src="https://connect-cdn.intellectualpoint.com/assets/images/logos/IntellectualPointIcon.png"
                        />
                      </div>
                    </div>
                    <div class="con-tab con-slot-tabs">
                      <login-jwt></login-jwt>
                    </div>
                    <div class="mt-8">
                      <div class="flex justify-between items-center">
                        <p class="font-light">Copyright 2022 © Intellectual Point</p>
                      </div>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </slide-x-left-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginJwt from './LoginJWT.vue'
import VideoBackground from 'vue-responsive-video-background-player'

export default {
  data () {
    return {
      transition: false
    }
  },
  components: { LoginJwt, VideoBackground },
  created () {
    delete this.$http.defaults.headers.common['Authorization']

    //Set Base URL
    // this.$http.defaults.baseURL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_ROOT_API_DEV : process.env.VUE_APP_ROOT_API_PROD
    this.$http.defaults.baseURL = process.env.VUE_APP_ROOT_API_PROD

    if (localStorage['accessToken'] && localStorage['accessToken']) {
      this.$router.push('/dashboard')
    }

    setTimeout(() => {
      this.transition = true
    }, 50)
  }
}
</script>

<style lang="scss">
.layout--full-page {
  .bg-img {
    background-color: #0d0e0f;
    background-image: url('https://connect-cdn.intellectualpoint.com/assets/images/backgrounds/connect-login-bg-v2-blue.png');
    background-position: center;
    background-size: cover;
  }

  .full-page-bg-color {
    background-color: #eff2f7;
  }
}

#page-login {
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      padding-top: 3rem;
    }
  }

  .bg-login-card {
    backdrop-filter: blur(50px);
    background: rgba(0, 0, 0, 0.35);
  }

  input {
    background-color: transparent;
  }
}
</style>
